// removed by extract-text-webpack-plugin
module.exports = {"contentView":"ContentView__contentView__E16pu","container":"ContentView__container__2CAK0","gray":"ContentView__gray__tl-yO"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ContentView/ContentView.scss
// module id = 807
// module chunks = 0